import React, {Component} from 'react'
import { fromAflac } from '../../modules/common'
import AflacHeader from './so/free/nav_header'

// Import Scss
import './Header.scss'

// Import Image
import logo from '../../images/logo.png'

class Header extends Component {

  render() {
    if (fromAflac()) {
      return <AflacHeader />
    }

    return (
      <div className="header">
        <header className={"header " + (this.props.openMobileMenu === true ? "open" : "")}>
          <div className="logo-wrapper">
            <a href={process.env.REACT_APP_HOME}>
              <img src={logo} alt='logo' />
              <small>がん専門医師からのセカンドオピニオン</small>
            </a>
          </div>
          <div className="hamburger-wrapper" onClick={this.props.toggleMobileMenu}>
            <div className={"hamburger " + (this.props.openMobileMenu === true ? "open" : "") }>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <ul className="list-menu">
            {/* <li>
              <a href={process.env.REACT_APP_HOME}>
                <span className="icon icon-home"></span>
                TOP
              </a>
            </li>
            <li>
              <a href={process.env.REACT_APP_HOME + "/doctor/"}>
                <span className="icon icon-doctor"></span>
                医師の方
              </a>
            </li>
            <li>
              <a href={process.env.REACT_APP_HOME + "/faq/"}>
                <span className="icon icon-qa"></span>
                よくある質問
              </a>
            </li> */}
            <li className="list-menu-button">
              <a className="headerSignupButton" href="/customer/signup">
                新規登録
              </a>
            </li>
            <li className="list-menu-button">
              <a className="headerLoginButton" href="/customer/login">
                ログイン
              </a>
            </li>
          </ul>
        </header>
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js